import {
  FilePdfOutlined,
  ProjectOutlined,
  PictureOutlined,
  MessageOutlined,
  InfoCircleOutlined,
  TeamOutlined,
  ApartmentOutlined,
  SolutionOutlined,
  HomeOutlined,
} from "@ant-design/icons";
import { Layout, Menu } from "antd";
import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";

import Logo from "../../../assets/images/logo.png";

const { Sider } = Layout;

const Sidebar = ({ collapsed }) => {
  const location = useLocation();

  const menuItemKeys = [
    "home",
    "company",
    "notices",
    "project",
    "vacancies",
    "gallery",
    "messages",
    "employees",
  ];
  const defaultSelectedKey = useMemo(() => {
    const [selectedKey] = menuItemKeys.filter((key) =>
      location.pathname?.includes(key)
    );
    return selectedKey;
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      width={250}
      style={{
        overflow: "auto",
        height: "100vh",
        position: "fixed",
        left: 0,
        top: 0,
        bottom: 0,
      }}
    >
      <div className="logo">
        <img
          alt="logo"
          id="logo"
          src={Logo}
          style={{ maxWidth: "220px", height: "auto" }}
        />
      </div>
      <Menu
        theme="dark"
        mode="inline"
        defaultSelectedKeys={[defaultSelectedKey]}
        items={[
          {
            key: "home",
            icon: <HomeOutlined />,
            label: (
              <Link to="/home">
                <span style={{ fontWeight: "bold" }}>Home</span>
              </Link>
            ),
          },
          {
            key: "company",
            icon: <InfoCircleOutlined />,
            label: (
              <Link to="/company">
                <span style={{ fontWeight: "bold" }}>Company Info</span>
              </Link>
            ),
          },
          {
            key: "notices",
            icon: <FilePdfOutlined />,
            label: (
              <Link to="/notices">
                <span style={{ fontWeight: "bold" }}>Notices</span>
              </Link>
            ),
          },
          {
            key: "projects",
            icon: <ProjectOutlined />,
            label: (
              <Link to="/projects">
                <span style={{ fontWeight: "bold" }}>Projects</span>
              </Link>
            ),
          },

          {
            key: "vacancies",
            icon: <SolutionOutlined />,
            label: (
              <Link to="/vacancies">
                <span style={{ fontWeight: "bold" }}>Vacancies</span>
              </Link>
            ),
          },

          {
            key: "gallery",
            icon: <PictureOutlined />,
            label: (
              <Link to="/gallery">
                <span style={{ fontWeight: "bold" }}>Gallery</span>
              </Link>
            ),
          },
          {
            key: "employees",
            icon: <ApartmentOutlined />,
            label: (
              <Link to="/employees">
                <span style={{ fontWeight: "bold" }}>Employees</span>
              </Link>
            ),
          },
          {
            key: "messages",
            icon: <MessageOutlined />,
            label: (
              <Link to="/messages">
                <span style={{ fontWeight: "bold" }}>Incoming Messages</span>
              </Link>
            ),
          },
          {
            key: "users",
            icon: <TeamOutlined />,
            label: (
              <Link to="/users">
                <span style={{ fontWeight: "bold" }}>Admin Users</span>
              </Link>
            ),
          },
        ]}
      />
    </Sider>
  );
};

export default Sidebar;
